import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SellIcon(props: IconProps) {
    return <Icon {...props} iconKey={"sell"}/>
}
